<ng-container *ngIf="topic">
    <div class="page-header-banner"><h1>Help and Advice: {{topic.name}}</h1></div>

    <div class="data-container">
        <div class="text-end">
            <button class="btn btn-primary-reverse btn-round btn-slim" (click)="addQuestion()">Add new Question</button>
        </div>

        <div class="no-results" *ngIf="!topic.questions.length">
            <p>No questions found</p>
        </div>

        <div class="mt-4" *ngIf="topic.questions.length">

            <div class="dd">
                <ol class="dd-list mt-2"
                    dragula="priCategory"
                    [(dragulaModel)]="topic.questions"
                    (dragulaModelChange)="drop($event)">
                    <li *ngFor="let q of topic.questions"
                        class="dd-item"
                        [ngClass]="{'dd-collapsed' : !q.open}">
                        <div class="dd-handle">
                            <span class="label label-info me-3">
                                <i class="fa fa-bars"></i>
                            </span>

                            <span class="float-right">
                                <a (click)="deleteConfirm(q)" style="margin-left: 10px">
                                    <img src="assets/images/icon-trash.svg" class="faq-que-trash">
                                </a>
                            </span>

                            <span class="float-right">
                                <a class="ms-3" (click)="editQuestion(q)">
                                    <img src="assets/images/icon-edit.svg" class="faq-que-edit">
                                    
                                </a>
                            </span>

                            <span class="float-right">
                                <a class="ms-3" (click)="toggleStatus(q)">
                                <i
                                    class="toggle fa"
                                    [ngClass]="{
                                    'fa-toggle-on text-success': q.status,
                                    'fa-toggle-off' : !q.status}"></i>
                                </a>
                            </span>

                            {{q.question}}
                            <span
                                class="badge hover ms-3"
                                (click)="togglePopular(q)"
                                [ngClass]="{'badge-light' : !q.popular, 'badge-success' : q.popular}">
                                Popular
                            </span>
                        </div>
                    </li>

                </ol>
            </div>





        </div>
<!--        <app-pagination *ngIf="params.pageArray.length" [params]="params" (update)="search()"></app-pagination>-->

    </div>

    <app-faq-question *ngIf="(overlays$ | async).faqQuestion" [question]="question" [topic]="topic" (closeAction)="closeAction($event)"></app-faq-question>

    <app-confirmation *ngIf="this.confirmationData.open" (complete)="confirmAction($event)" [data]="confirmationData"></app-confirmation>

</ng-container>

